import type { DatasetsInterventionCreateVariables } from "./datasets.type";
import type { ObservationSimpleWithDatasets } from "@/entities/observation";
import type { UseCreateOptions } from "@/hooks/queries";
import type { Int } from "@/types";

import { useCreate } from "@/hooks/queries";

type Data = ObservationSimpleWithDatasets;
type Variables = DatasetsInterventionCreateVariables;
type Options = Omit<UseCreateOptions<Data, Variables>, "rootId">;

export const useDatasetsInterventionCreate = (
  interventionId: Int,
  options?: Options
) => {
  return useCreate<Data, Variables>("interventions.observations", {
    ...options,
    rootId: interventionId,
  });
};
